import SaleReportsByOrder from './SaleReportsByOrder';

export default SaleReportsByOrder
